import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../../hooks/useTitle";
import { withAuth } from "../../../../../components/HOC/withAuth";
import CardContainer from "../../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../../shared/utils";
import ProductionReportShell from "../ProductionReportShell";
import GroupByChips from "../GroupByChips";
import { useMachineProductionReport } from "../useMachineProductionReport";

const weekdayFromDateKey = (dk) => {
  const [y, m, d] = dk.split("-").map(Number);
  return new Date(y, m - 1, d).getDay();
};

const buildWeekdayAvgLine = (dateKeys, totalPerDate) => {
  const buckets = new Map();
  dateKeys.forEach((dk, i) => {
    const wd = weekdayFromDateKey(dk);
    if (!buckets.has(wd)) buckets.set(wd, []);
    buckets.get(wd).push(totalPerDate[i]);
  });

  const avgByWeekday = new Map();
  buckets.forEach((values, wd) => {
    avgByWeekday.set(
      wd,
      Math.round(values.reduce((s, v) => s + v, 0) / values.length),
    );
  });

  return dateKeys.map((dk) => avgByWeekday.get(weekdayFromDateKey(dk)) ?? 0);
};

const ProductionByMachineTrend = () => {
  useTitle("Rovion MES - Üretim Çizgi Grafiği");
  const {
    filters,
    machines,
    shifts,
    loading,
    derived,
    groupBy,
    setGroupBy,
    fetchData,
    toasts,
    dismissToast,
  } = useMachineProductionReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!derived) return <SectionEmpty />;
    const { dateKeys, totalPerDate } = derived;
    if (dateKeys.length < 2)
      return <SectionEmpty msg="Trend için yeterli veri yok." />;

    const avgLine = buildWeekdayAvgLine(dateKeys, totalPerDate);

    return (
      <>
        {/* <GroupByChips groupBy={groupBy} onChange={setGroupBy} /> */}
        <CardContainer title="Üretim Trendi">
          <ReactApexChart
            type="line"
            series={[
              { name: "Toplam Üretim", type: "area", data: totalPerDate },
              {
                name: "Gün Ortalaması (Pzt–Pzt)",
                type: "line",
                data: avgLine,
              },
            ]}
            options={{
              chart: {
                type: "line",
                toolbar: { show: false },
                fontFamily: "inherit",
                foreColor: "#334155",
              },
              colors: ["#0f766e", "#f97316"],
              stroke: { width: [2, 2], curve: "smooth", dashArray: [0, 5] },
              fill: {
                type: ["gradient", "solid"],
                gradient: { opacityFrom: 0.4, opacityTo: 0.05 },
              },
              xaxis: {
                categories: dateKeys,
                labels: { rotate: -45, style: { fontSize: "10px" } },
              },
              yaxis: {
                labels: { formatter: (v) => v.toLocaleString("tr-TR") },
              },
              legend: { position: "top" },
              dataLabels: { enabled: false },
              grid: { borderColor: "#f0f2f5" },
              tooltip: {
                shared: true,
                intersect: false,
                y: { formatter: (v) => v.toLocaleString("tr-TR") },
              },
            }}
            height={280}
          />
        </CardContainer>
      </>
    );
  };

  return (
    <ProductionReportShell
      title="Üretim Çizgi Grafiği"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </ProductionReportShell>
  );
};

export default withAuth(ProductionByMachineTrend);
